import type { ProductColour } from '../colour/productColour';
import { CUSTOM_PRODUCT_COLOUR_ID } from '../colour/productColours';

export interface ColourCategory {
  id: string;
  label: string;
  colourIds: string[];
}

export const COLOUR_CATEGORIES: ColourCategory[] = [
  {
    id: 'whites',
    label: 'Whites',
    colourIds: ['white', 'cream', 'clotted-cream'],
  },
  {
    id: 'greys',
    label: 'Greys',
    colourIds: [
      'anthracite-grey',
      'slate-grey',
      'basalt-grey',
      'agate-grey',
      'pebble-grey',
      'elephant-grey',
      'stone-grey',
      'dusty-grey',
      'pearl-grey',
      'french-grey',
      'granite-grey',
      'twilight-grey',
      'claystone',
      'quartz',
      'aluminium',
    ],
  },
  {
    id: 'greens',
    label: 'Greens',
    colourIds: [
      'sage',
      'chartwell-green',
      'cotswold-green',
      'racing-green',
      'balmoral-green',
      'forest-green',
    ],
  },
  {
    id: 'blues',
    label: 'Blues',
    colourIds: [
      'duck-egg-blue',
      'steel-blue',
      'french-navy',
      'pottery-blue',
      'peacock-blue',
      'brilliant-blue',
    ],
  },
  {
    id: 'reds',
    label: 'Reds',
    colourIds: ['ruby-red', 'burgundy', 'black', 'black-brown'],
  },
  {
    id: 'woods',
    label: 'Woods',
    colourIds: [
      'golden-oak',
      'irish-oak',
      'english-oak',
      'turner-oak',
      'silvered-oak',
      'walnut',
      'rosewood',
      'mahogany',
      'dark-oak',
      'natural-timber',
    ],
  },
  {
    id: 'custom',
    label: 'Custom',
    colourIds: [CUSTOM_PRODUCT_COLOUR_ID],
  },
];

export function coloursInCategory(
  category: ColourCategory,
  library: ProductColour[]
): ProductColour[] {
  return category.colourIds
    .map((id) => library.find((colour) => colour.id === id))
    .filter((colour): colour is ProductColour => Boolean(colour));
}
